export default __webpack_public_path__ + "static/media/vnpay.0e278283.jpg";